<template>
  <div class="m_page--media m_mediaPublication" :style="mediaStyles(media)">
    <div
      class="mediaContainer"
      :class="['type-' + media.type]"
      :style="contentStyles(media)"
    >
      <template
        v-if="
          media.hasOwnProperty('_source_media_meta') &&
            media._source_media_meta.type === 'text'
        "
      >
        <div class="mediaTextContent">
          <div v-html="media._source_media_meta.content" />
        </div>
      </template>
      <template
        v-if="
          !media.hasOwnProperty('_source_media_meta') && media.type === 'text'
        "
      >
        <div class="mediaTextContent">
          <div v-html="media.content" />
        </div>
      </template>
      <template
        v-else-if="
          media.hasOwnProperty('_source_media_meta') &&
            media._source_media_meta.type === 'image'
        "
      >
        <img
          :src="setSrcFromDodocServer(media._source_media_meta.thumbs[2].path)"
        />
      </template>
      <template
        v-else-if="
          media.hasOwnProperty('_source_media_meta') &&
            media._source_media_meta.type === 'video'
        "
      >
        <video
          :src="setMediaSrcFromOriginalProject(media)"
          :poster="
            setSrcFromDodocServer(
              media._source_media_meta.thumbs[0].thumbsData[2].path
            )
          "
          controls
          preload="none"
        />
      </template>
      <template
        v-else-if="
          media.hasOwnProperty('_source_media_meta') &&
            media._source_media_meta.type === 'audio'
        "
      >
        <audio
          :src="setMediaSrcFromOriginalProject(media)"
          controls
          preload="none"
        />
      </template>

      <template
        v-else-if="
          ['ellipsis', 'rectangle', 'line', 'arrow'].includes(media.type)
        "
      >
        <svg
          viewBox="0 0 100 100"
          :width="`${media.width}mm`"
          :height="`${media.height}mm`"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            v-if="media.type === 'ellipsis'"
            cx="50"
            cy="50"
            r="50"
            vector-effect="non-scaling-stroke"
          />
          <rect
            v-if="media.type === 'rectangle'"
            width="100"
            height="100"
            vector-effect="non-scaling-stroke"
          />
          <line
            v-if="media.type === 'line'"
            x1="0"
            y1="50"
            x2="100"
            y2="50"
            vector-effect="non-scaling-stroke"
          />
          <g v-if="media.type === 'arrow'">
            <line
              x1="0"
              y1="50"
              x2="100"
              y2="50"
              vector-effect="non-scaling-stroke"
            />
            <g
              transform="
                translate(100, 50)"
              preserveAspectRatio
            >
              <line
                x1="0"
                y1="0"
                x2="-10"
                y2="-10"
                vector-effect="non-scaling-stroke"
              />

              <line
                x1="0"
                y1="0"
                x2="-10"
                y2="10"
                vector-effect="non-scaling-stroke"
              />
            </g>
          </g>
        </svg>
      </template>
    </div>
    <div
      v-if="
        media.hasOwnProperty('_source_media_meta') &&
          media._source_media_meta.caption
      "
      class="m_page--media--caption"
    >
      {{ media._source_media_meta.caption }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    media: Object,
    page: Object,
    zoom: Number,
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  computed: {},
  methods: {
    mediaStyles(media) {
      const w = media.hasOwnProperty("width") ? media.width : 100;
      const h = media.hasOwnProperty("height") ? media.height : 100;
      const x = media.hasOwnProperty("x") && media.x !== 0 ? media.x : 10;
      const y = media.hasOwnProperty("y") && media.y !== 0 ? media.y : 20;
      const rotate = media.hasOwnProperty("rotate") ? media.rotate : 0;
      const z_index = media.hasOwnProperty("z_index") ? media.z_index : 0;

      let mediaStyles = `
        transform: translate(${x}mm, ${y}mm) rotate(${rotate}deg);
        width: ${w}mm;
        height: ${h}mm;
        z-index: ${z_index};
      `;
      return mediaStyles;
    },
    contentStyles(media) {
      const font_size_percent = media.hasOwnProperty("font_size_percent")
        ? media.font_size_percent
        : 100;
      const fill_color =
        media.hasOwnProperty("fill_color") && !!media.fill_color
          ? media.fill_color
          : "transparent";
      const stroke_color =
        media.hasOwnProperty("stroke_color") && !!media.stroke_color
          ? media.stroke_color
          : "transparent";

      let css = `
        --font_size_percent: ${font_size_percent}%;
        --fill_color: ${fill_color};
        --stroke_color: ${stroke_color};
        --stroke_width: ${4 * this.zoom}px;
      `;

      if (media.custom_css) css += media.custom_css;

      return css;
    },

    setMediaSrcFromOriginalProject(media) {
      const path =
        media.slugProjectName + "/" + media._source_media_meta.media_filename;
      return this.setSrcFromDodocServer(path);
    },

    setSrcFromDodocServer(path) {
      return this.$root.dodoc_url + path;
    },
  },
};
</script>
<style lang="scss">
.mediaTextContent {
  position: relative;
  color: inherit;

  > *:first-child {
    margin-top: 0;

    > *:first-child {
      margin-top: 0;
    }
  }

  ._no_textcontent {
    font-style: italic;
    color: #666666;
  }

  p {
    font-family: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  p,
  ul,
  ol,
  table,
  figure,
  blockquote {
    margin: var(--spacing) 0;
  }

  // https://www.gridlover.net/try
  // fz : 16px
  // lh : 1.41
  // scale : 1.31

  font-size: 1em;
  line-height: 1.2375;
  // max-width: 773px;
  // margin: auto;

  h1,
  .h1 {
    font-size: 2.25em;
    line-height: 1.27777778em;
    margin-top: 0.63888889em;
    margin-bottom: 0em;
  }
  h2,
  .h2 {
    font-size: 1.6875em;
    line-height: 1.7037037em;
    margin-top: 0.85185185em;
    margin-bottom: 0em;
  }
  h3,
  .h3 {
    font-size: 1em;
    line-height: 1.4375em;
    margin-top: 1.4375em;
    margin-bottom: 0em;
  }
  h4,
  .h4 {
    font-size: 1em;
    line-height: 1.4375em;
    margin-top: 1.4375em;
    margin-bottom: 0em;
  }
  h5,
  .h5 {
    font-size: 1em;
    line-height: 1.4375em;
    margin-top: 1.4375em;
    margin-bottom: 0em;
  }
  p,
  ul,
  ol,
  pre,
  table,
  blockquote {
    margin-top: 0em;
    margin-bottom: 0em;
  }
  ul ul,
  ol ol,
  ul ol,
  ol ul {
    margin-top: 0em;
    margin-bottom: 0em;
  }

  /* Let's make sure all's aligned */
  hr,
  .hr {
    border: 1px solid;
    margin: -1px 0;
  }
  a,
  b,
  i,
  strong,
  em,
  small,
  code {
    // line-height: 0;
  }
  sub,
  sup {
    // line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sup {
    top: -0.5em;
  }
  sub {
    bottom: -0.25em;
  }
  // gridlover end

  h1,
  h2 {
    & + h2 {
      margin-top: 0;
    }
  }

  ol,
  ul {
    padding-left: 1.5em;

    > li {
      list-style-type: none;
    }
  }
  ul > li::before {
    content: "\2022";
  }

  li::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }

  ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
      list-9;
    counter-increment: list-0;
  }
  ol li:before {
    content: counter(list-0, decimal) ". ";
  }

  strong,
  b {
    font-weight: 700;
  }

  a {
    text-decoration: underline;
    text-decoration-style: solid;
    color: #1d327f;
    font-weight: inherit;
  }

  h1,
  h2 {
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }

  h1 {
    font-weight: 700;
  }

  h2,
  h3,
  h4 {
    font-weight: 700;
  }

  blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }

  code,
  pre {
    background-color: #333;
    color: white;
    border-radius: 3px;
    font-family: "Fira Code";
    font-weight: 500;
  }
  pre {
    white-space: pre-wrap;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px;
  }
  code {
    // font-size: 85%;
    // padding: 2px 4px;
  }

  .ql-align-center {
    text-align: center;
  }
  .ql-align-justify {
    text-align: justify;
  }
  .ql-align-right {
    text-align: right;
  }

  iframe {
    width: 100%;
  }
}

.m_mediaPublication {
  position: absolute;

  min-width: 5mm;
  min-height: 5mm;
  z-index: 0;

  transform-origin: center center;

  .mediaContainer {
    overflow: hidden;
    height: 100%;
    width: 100%;
    outline: 2px solid transparent;
    // background-color: white;

    font-size: var(--font_size_percent);

    > * {
      width: 100%;
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &:not(.type-ellipsis):not(.type-rectangle):not(.type-arrow):not(.type-line) {
      background-color: var(--fill_color);
      outline-color: var(--stroke_color);
      outline-width: 4px;
      outline-style: solid;
    }

    &.type-text {
      background-color: rgba(255, 255, 255, 0.95);

      iframe {
        width: 100%;
      }

      .ql-container {
        display: flex;
        flex-flow: column;

        > .ql-editor {
          flex: 1 1 auto;
        }
      }
    }

    &.type-ellipsis,
    &.type-rectangle,
    &.type-line,
    &.type-arrow {
      overflow: visible;
      svg {
        width: 100%;
        height: 100%;
        fill: var(--fill_color);
        stroke: var(--stroke_color);
        stroke-width: var(--stroke_width);
        overflow: visible;
      }
    }

    &.type-video {
      .plyr {
        border-radius: 6px;
      }
      .plyr--video,
      .plyr__video-wrapper,
      .plyr__poster {
        background-color: transparent;
      }
      img {
        object-fit: contain;
        background: transparent;
      }
    }

    &.type-stl iframe {
      border: 2px solid #f1f1f1;
      background: #f1f1f1;
      width: 100%;
      height: 100%;
    }
  }

  .mediaCaption {
    margin-top: 0;
    font-size: 85%;
  }
}
</style>
